import { render, staticRenderFns } from "./InstallPwaBanner.vue?vue&type=template&id=ec882d8a&scoped=true"
import script from "./InstallPwaBanner.vue?vue&type=script&lang=ts"
export * from "./InstallPwaBanner.vue?vue&type=script&lang=ts"
import style0 from "./InstallPwaBanner.vue?vue&type=style&index=0&id=ec882d8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec882d8a",
  null
  
)

export default component.exports